import metadata from '../../metadata.web.json';

export default metadata;
